import { action, thunk, persist } from 'easy-peasy';
import { httpGetTags } from "services/tags"

const model = {
  loading: false,
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
  count: 0,
  setCount: action((state, payload) => {
    state.count = payload
  }),
  // My sectors list
  tags: [],
  setTags: action((state, payload) => {
    if (payload) {
      state.tags = payload
    }
  }),
  getTags: thunk(async (actions, payload) => {
    actions.setLoading(true)
    httpGetTags().then(response => {
      if (response.status === 200 && response?.data) {
        actions.setLoading(false)
        actions.setTags(response?.data)
        if (response?.data.length > 0) {
          actions.setCount(response?.data.length)
        }
        else {
          actions.setCount(0)
        }
      }
    }, error => {
      
    }).finally(() => {
      actions.setLoading(false)
    })
    
  }),

};

export default model;